import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

const LoginSignUpButton = (props) => {
    const {handleLoginModalOpen}=props
    return (
        <div className="clearfix">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={(e) => handleLoginModalOpen(e, 0)}
        >
          Login
        </button>{' '}
        <span className="mx-2 fw-bold">- OR -</span>{' '}
        <button
          type="button"
          className="btn btn-outline-secondary btn-sm"
          onClick={(e) => handleLoginModalOpen(e, 1)}
        >
          Create Account
        </button>
      </div>
    )
}

LoginSignUpButton.propTypes = {
    handleLoginModalOpen: PropTypes.func,
}

LoginSignUpButton.defaulProps = {
    dispatch: noop,
}

export default LoginSignUpButton
